export class ProductsQuery {
  constructor () {
    this.text = undefined;
    this.current = undefined;
    this.pageSize = undefined;
    this.brand = undefined;
    this.macroCategory = undefined;
    this.microCategory = undefined;
    this.published = undefined;
  }

  static get KEYS () {
    return {
      MACRO_CATEGORY: 'macroCategory',
      MICRO_CATEGORY: 'microCategory',
      BRAND: 'brand',
      TEXT: 'text',
      PUBLISHED: 'published'
    };
  }
}
